import React from 'react'
import { useEffect, useRef } from 'react'
import lottie from 'lottie-web'
import PropTypes from 'prop-types'

export default function LottieAnimation({ loop = false, autoplay = true, speed = 1, animationData }) {
  const containerRef = useRef(null)

  useEffect(() => {
    const animation = lottie.loadAnimation({
      container: containerRef.current,
      renderer: 'svg',
      loop,
      autoplay,
      animationData,
    })
    animation.setSpeed(speed)

    return () => animation.destroy()
  }, [loop, autoplay])

  return (
    <div
      ref={containerRef}
      className='lottie-animation'
    />
  )
}

LottieAnimation.propTypes = {
  loop: PropTypes.bool,
  autoplay: PropTypes.bool,
  speed: PropTypes.number,
  animationData: PropTypes.object,
}
